<h1 class="h3 mb-2 text-gray-800">Realizar Pago</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Pago de tratamiento</h6>
    </div>
    <div class="card-body">
        <p [innerHTML]="caso.descripcion_tratamiento"></p>
        <p>Para iniciar la planificación del caso es necesario realizar el pago de <b>la suma de
                {{caso.precio_tratamiento_bs}} Bs.</b><br /><br />
            <app-datos-cobro></app-datos-cobro>
        </p>
        <div class="row">
            <div class="col-6">
                <form name="form" (ngSubmit)="f.form.valid && enviarDatos()" #f="ngForm">
                    <div class="form-group">
                        <label>Enviar comprobante de pago</label>
                        <div *ngIf="urlComprobante"><img [src]="urlComprobante" height="200"></div>
                        <input type="file" accept=".jpg, .jpeg, .png" #fileuploadTop="ngModel" [(ngModel)]="comprobante"
                            name="comprobante" (change)="seleccionarComprobante($event)" class="form-control"
                            [ngClass]="{'is-invalid':  f.submitted && fileuploadTop.invalid}" required />
                        <div *ngIf="f.submitted && fileuploadTop.invalid" class="invalid-feedback">
                            <div *ngIf="fileuploadTop.errors.required">El comprobante es requerido</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="direccionEntrega">Ingrese la dirección de entrega del tratamiento BeAlign de su
                            paciente</label>
                        <textarea class="form-control" name="direccionEntrega" #direccionEntrega="ngModel"
                            [ngClass]="{'is-invalid':  f.submitted && direccionEntrega.invalid}" required
                            [(ngModel)]="caso.direccion_entrega"></textarea>
                        <div *ngIf="f.submitted && direccionEntrega.invalid" class="invalid-feedback">
                            <div *ngIf="direccionEntrega.errors.required">La dirección es requerida</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Seleccione su ubicación en el mapa</label>
                        <google-map width="750px" height="450px" [center]="center" [zoom]="zoom"
                            (mapClick)="clickMapa($event)">
                            <map-marker [position]="marker.position" [label]="marker.label" [title]="marker.title"
                                [options]="marker.options">
                            </map-marker>
                        </google-map>
                    </div>

                    <div class="form-group">
                        <button type="submit" class="btn btn-primary">Enviar para verificación</button>&nbsp;
                        <a href="javascript:void(0)" class="btn btn-danger"
                            (click)="doctorRechazaPresupuesto()">Rechazar presupuesto</a>&nbsp;
                        <a [routerLink]="'/casos/'+caso.id+'/verpaciente'" class="btn btn-link">Volver</a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<script async defer type="text/javascript" [src]="getGmapsUrl()"> </script>